import * as Yup from "yup";

export const validationSchema = Yup.object({
  company: Yup.string().required("Required Field"),
  companyNumber: Yup.string().max(15, "Maximum 15 Number Allowed").required("Required Field"),
  adminEmail: Yup.string().email("Invalid Email Address").required("Required Field"),
  adminNumber: Yup.string().required("Required Field"),
  vatNumber: Yup.string().required("Required Field"),
  postCode: Yup.string().min(6,'Minimum 6 Digit Required').required("Required Field"),
  file: Yup.mixed()
  .required("Required Field")
  .test("type", "Invalid file type. Supported file type is Pdf, Docx", (value) => {
    return value && value?.type === "application/pdf";
  }),
});
